<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 구분 -->
    <div>
      <h5><i class="dot"></i> 조사 구분</h5>
      <div class="grid grid-cols-4 mt-4">
        <div>
          <vs-checkbox v-for="value in ['정기조사']"
                       class="mr-6"
                       :checked="form.regularly === value"
                       @change="form.regularly = form.regularly === value ? '' : value ">
            {{value}}
          </vs-checkbox>
        </div>
        <div>
          <vs-checkbox v-for="value in ['수시조사 - 근골격계 질환자 발생 시', '수시조사 - 새로운 작업 및 설비 도입 시', '수시조사 - 업무의 양과 작업공정 등 작업환경 변경 시']"
                       class="mr-6 mb-2"
                       :checked="form.regularly === value"
                       @change="form.regularly = form.regularly === value ? '' : value ">
            {{value}}
          </vs-checkbox>
        </div>
      </div>
    </div>

    <table-custom
      :board="board"
      :is-print="isPrint"
      title="작업환경 개선 계획서"
      :tableData="[
        { id: 'input1', title: 'No.', type: 'no', placeholder: '내용', width: 60 },
        { id: 'input2', title: '공정명', type: 'text', placeholder: '내용' },
        { id: 'input3', title: '작업내용', type: 'text', placeholder: '내용' },
        { id: 'input4', title: '개선결과', type: 'textarea', placeholder: '내용' },
        { id: 'input5', title: '사진', type: 'photo', width: 194 },
        { id: 'input6', title: '개선일자', type: 'date', placeholder: '내용' },
        { id: 'input7', title: '개선조치 담당자', type: 'text', placeholder: '내용', width: 140 },
      ]"
      v-model="form.작업환경"
      class="mt-28px"
    />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="mt-28px" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";
import TableCustom from "@/components/TableCustom.vue";
import FileUploadModule from "@/views/modules/FileUploadModule";

export default {
  components: {
    FieldSelectModule,
    PrintCheckbox,
    TableCustom,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  methods: {},
  data() {
    return {
      form: {
        stdInfo: {},
        regularly: "",

        작업환경: [],
        fileList: [],
      },
    };
  },
};
</script>
